import { Box, Text, Textfield, Grid, useTheme } from '@simplywallst/ui-core';
import { useState, useEffect } from 'react';
import { useDebounce } from '@simplywallst/hooks/useDebounce';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import Tooltip from '@/components/Tooltip';

interface Props {
  keywords?: string;
  onChange: (keywords: string) => void;
}

export function KeywordSearch({ keywords, onChange }: Props) {
  /**
   * TODO: retain keyword search from saved screeners
   */
  const [query, setQuery] = useState(keywords);
  const debouncedSearch = useDebounce(query, 800);

  useEffect(() => {
    if (typeof debouncedSearch === 'string') {
      onChange(debouncedSearch);
    }
  }, [debouncedSearch, onChange]);

  const theme = useTheme();
  return (
    <Box
      borderRadius="x1spacePx"
      padding="x1spacePx"
      paddingLeftMd="x2spacePx"
      paddingRightMd="x2spacePx"
      style={{
        backgroundColor: 'var(--s-color-surface-2)',
      }}
    >
      <Grid gap="12px" templateColumns="auto 1fr auto" alignItems="center">
        <Grid>
          <label htmlFor="keyword-search" style={{ marginBottom: 0 }}>
            <Text as="span" typography="xSmallStrong">
              Keywords
            </Text>
          </label>
        </Grid>
        <Grid>
          <Textfield
            id="keyword-search"
            type="search"
            placeholder="e.g. nuclear power, GPU, self driving cars, solar"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </Grid>
        <Grid>
          <Tooltip title="Beta Feature. Use keywords for specific products, ingredients, materials, themes and sub-industries.">
            <InformationSolid fill={theme.color.whiteRGBA(0.5)} />
          </Tooltip>
        </Grid>
      </Grid>
    </Box>
  );
}
